import { getRouteApi } from '@tanstack/react-router'
import { Suspense } from 'react'
import { z } from 'zod'

import { lazySkelPage, lenientSkel, SkelPageLoading, ULID_RE } from '@/routes/skel.index'

/**
 * `/skel/new?sheet=<ulid>` — the parts-sheet splitter (docs/SKEL-EDITOR.md §5.4 "Splitter").
 *
 * Without `sheet` the page starts with an upload; with it, it resumes wherever that sheet is
 * (uploaded → choose how to split, analyzing → progress, ready → review, failed → retry). A
 * malformed id is dropped by the lenient schema (→ upload), never a crash.
 */

export const skelNewSearchSchema = z.object({
  sheet: lenientSkel(z.string().regex(ULID_RE)),
})
export type SkelNewSearch = z.infer<typeof skelNewSearchSchema>

export function validateSkelNewSearch(input: Record<string, unknown>): SkelNewSearch {
  return skelNewSearchSchema.parse(input)
}

export const SKEL_NEW_ROUTE_ID = '/skel/new' as const
const route = getRouteApi(SKEL_NEW_ROUTE_ID)

const SheetSplitter = lazySkelPage(() => import('@/features/skel/SheetSplitter'), 'parts-sheet splitter')

export function SkelNewPage() {
  const { sheet } = route.useSearch()
  return (
    <Suspense fallback={<SkelPageLoading label="Opening the splitter…" />}>
      <SheetSplitter sheetId={sheet} />
    </Suspense>
  )
}
